export default __webpack_public_path__ + "static/media/icon3@3x_.18897abd.png";